import AxiosClient from "../../../services/axios.services";

class CampañasServices {
  getCampañas = (params, userName) =>
    AxiosClient.get(
      userName
        ? "/api/app/Clima_Campania_segmento/"
        : "/api/app/Clima_Campania/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getResponsables = (params) =>
    AxiosClient.get("/api/app/Clima_Usuarios_Responsables/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getResponsablesOtro = (params) =>
    AxiosClient.get("/api/app/Clima_Usuarios_Responsables/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getCampaña = (id) =>
    AxiosClient.get(`/api/app/Clima_Campania/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveCampaña = (data) =>
    AxiosClient.post("/api/app/Clima_Campania/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editCampaña = (id, data) =>
    AxiosClient.put(`/api/app/Clima_Campania/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteCampaña = (id) =>
    AxiosClient.delete(`/api/app/Clima_Campania/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
  saveCampañaSegmento = (data) =>
    AxiosClient.post("/api/app/BulkCreateClimaCampaSegmento/", data, {
      headers: { "Content-Type": "application/json" },
    });

  getSendData = (data) =>
    AxiosClient.post("/api/app/Clima_usuario_en_encuesta/", data, {
      headers: { "Content-Type": "application/json" },
    });

  generateLink = (params) =>
    AxiosClient.get("/api/app/Clima_generacion_enlace_encuestas/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  sendMail = (data) =>
    AxiosClient.post("/api/app/Clima_envio_campania_all/", data, {
      headers: { "Content-Type": "application/json" },
    });

  sendSurveyEmployee = (data) =>
    AxiosClient.post("/api/app/Clima_envio_campania_colaborador/", data, {
      headers: { "Content-Type": "application/json" },
    });

  getSurvey = (params) =>
    AxiosClient.get("/api/app/Clima_Encuesta/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
}

export default new CampañasServices();
